import { Controller } from 'stimulus';
import Swiper, { A11y, Navigation, Pagination } from 'swiper';

Swiper.use([A11y, Navigation, Pagination]);

export default class extends Controller {
  static targets = [
    'slider',
    'carousel',
    'card',
    'statusBar',
    'next',
    'prev',
  ]

  connect() {
    this.initSwiper();
  }

  disconnect() {
    this.destroySwiper();
  }

  initSwiper() {

    // Short-circuit if swiper is already initialized, or we don't want it to be
    if (this.swiper) return;

      this.swiper = new Swiper(this.sliderTarget, {
        slidesPerView: 2.66,
        spaceBetween: 30,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        breakpoints: {
          700: {
            slidesPerView: 2.66,
            navigation: {
              prevEl: this.prevTarget,
              nextEl: this.nextTarget
            },
          },
          1500: {
            slidesPerView: 4,
          },
        },
      });
    }
    destroySwiper() {
      // Short-circuit if swiper is not initialized
      if (!this.swiper) return;

      // Destroy the swiper instance
      this.swiper.destroy(true, true);
    }
}

